<a class="decorated-text-cell-container w-100 d-flex flex-row primary-color-text-hover" [ngClass]="item.style | floCssClassSanitize" floAnalytics [floCustomLink]="item.action.url" (click)="handleClick(item.action)" [analyticsProperties]="item.action.analytics">
  <div *ngIf="!!item.leadingDecorator" class="leading-decorator d-flex flex-row align-items-center position-relative">
      <ng-container *ngIf="item.leadingDecorator | floIsIcon">
        <flo-svg-icon
          data-test="leading-decorator-icon"
          class="leading-decorator-icon d-flex align-items-center justify-content-center"
          [icon]="item.leadingDecorator.style"
          width="14px"
        ></flo-svg-icon>
      </ng-container>
      <ng-container *ngIf="item.leadingDecorator | floIsImage">
        <flo-image
          class="leading-decorator-image"
          [image]="item.leadingDecorator"
          data-test="leading-decorator-image"
        >
        </flo-image>
      </ng-container>
      <ng-container *ngIf="item.leadingDecoratorSecondaryIcon">
        <div class="leading-decorator-secondary-icon-container rounded-circle position-absolute">
          <flo-svg-icon
            class="leading-decorator-secondary-icon"
            [icon]="item.leadingDecoratorSecondaryIcon.style"
            width="14px"
          ></flo-svg-icon>
        </div>
      </ng-container>
  </div>
  <div class="details d-flex flex-row align-items-center">
    <p data-test="decorated-text-cell-title" class="m-0 color-900 apply-text-hover text-truncate">
      {{ item.title.text }}
      <span *ngIf="item.subtitle" data-test="item-subtitle" class="color-500 apply-text-hover ps-2">&middot; <span class="ps-2">{{ item.subtitle.text }}</span></span>
    </p>
  </div>
  <div class="trailing-decorator d-flex flex-row align-items-center justify-content-end">
   <ng-container *ngIf="!!item.trailingDecorator">
     <ng-container *ngFor="let icon of item.trailingDecorator; trackBy: trackByStyle">
       <div *ngIf="icon | floIsIcon" class="pb-1" [class]="icon.style">
         <flo-svg-icon
           data-test="decorated-text-icon"
           class="ps-2 text-trailing-decorator-icon svg-vertical-align-text-bottom color-900"
           [ngClass]="{'text-ignite': icon.style === 'icon-star-filled'}"
           [icon]="icon.style"
         ></flo-svg-icon>
       </div>
     </ng-container>
   </ng-container>
  </div>
</a>
